/**
 * 工具类
 */
import Vue from 'vue'
import CryptoJS from 'crypto-js'

//加密密钥
const keyStr = 'ciowi^&370@xo16#';
//千位显示
const reg = /\d{1,3}(?=(\d{3})+$)/g;

export default {

  // 监听语言变化
  languageChange(that,enVal,znVal){
    that.$bus.$on('onLanguageChange',()=>{
      that.labelCol = {
        span: localStorage.getItem('i18n').startsWith('zh') ? znVal.labelCol : enVal.labelCol
      }
      that.wrapperCol = {
        span: localStorage.getItem('i18n').startsWith('zh')  ? znVal.wrapperCol : enVal.wrapperCol
      }
    })
  },

  //加密
  reload() {
    return 0;
  },

  //加密
  encrypt(word) {
    let key = CryptoJS.enc.Utf8.parse(keyStr);//Latin1 w8m31+Yy/Nw6thPsMpO5fg==
    let srcs = CryptoJS.enc.Utf8.parse(word);
    let encrypted = CryptoJS.AES.encrypt(srcs, key, {mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7});
    return encrypted.toString();
  },
  //解密
  decrypt(word) {
    ;
    let key = CryptoJS.enc.Utf8.parse(keyStr);//Latin1 w8m31+Yy/Nw6thPsMpO5fg==
    let decrypt = CryptoJS.AES.decrypt(word, key, {mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7});
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
  },

  formatDate(date, fmt) {
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    let o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds()
    };
    for (let k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        let str = o[k] + '';
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : this.padLeftZero(str));
      }
    }
    return fmt;
  },
  padLeftZero(str) {
    return ('00' + str).substr(str.length);
  },
  showThousandNumber(value){
    let showValue = "-";
    if (typeof value == "undefined" || value == null) {
      return showValue;
    }
    let dot = "";
    let value_str = String(value);
    let dot_inx = value_str.indexOf(".");
    if (dot_inx >= 0) {
      dot = value_str.substring(dot_inx, value_str.length);
    }
    showValue = (Math.floor(value) + "").replace(reg, "$&,");
    return showValue + dot;
  },
  
  // 获取 当前时间、前几个月（正数）或后几个月（负数）时间 
  // params 间隔的月份 （当年：0，前一年：1，明年：-1）
  getDate(params) {
    let dt = new Date();
    dt.setMonth(dt.getMonth() - Number(params));
    dt.toLocaleString()
    let year = dt.getFullYear();
    let month = dt.getMonth() + 1 < 10 ? "0" + (dt.getMonth() + 1) : dt.getMonth() + 1;
    return year + "-" + month;   
  },

  deepCopy(value) {
    if(value instanceof Function)return value
    else if (value instanceof Array) {
        var newValue = []
        for (let i = 0; i < value.length; ++i) newValue[i] = this.deepCopy(value[i])
        return newValue
    } else if (value instanceof Object) {
        var newValue = {}
        for (let i in value) newValue[i] = this.deepCopy(value[i])
        return newValue
    } else return value
  },

  onlyChildrenCanSelect(obj) {
    let arr = []
    obj.map(item => {
        if (item.children.length) {
            item.disabled = true

            item.children = this.onlyChildrenCanSelect(item.children)
            // item.children
        }
        arr.push(item)
    })
    return arr
},

}
